import React, { useState, useEffect } from 'react';

export default function BackToTopButton() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 350) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!showButton) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Rul til toppen"
      className="fixed bottom-6 right-6 z-40 bg-[#1F2A37] hover:bg-[#d75d5a] text-white w-12 h-12 flex items-center justify-center shadow-lg transition-all duration-300 transform hover:-translate-y-1 active:translate-y-0 group border border-white/20"
      title="Rul til toppen"
    >
      <i className="fa-solid fa-arrow-up text-lg transition-transform duration-300 group-hover:-translate-y-0.5"></i>
    </button>
  );
}
